<template>
  <modal class="analytics-photo-modal" @modal-close="handleClose">
    <ImageAsset
      :photo="photo"
      class="rounded my-2 h-screen image-bg-cover-no-repeat"
    />
  </modal>
</template>

<script>
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';

  export default {
    name: 'PhotoModal',
    components: { ImageAsset },
    props: {
      photo: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
    },
  };
</script>
